import React from 'react';
import { useGame } from '../context/GameContext';

const MobileControls = () => {
    const { socket, isMobile } = useGame();

    const handleFeed = () => {
        if (socket) {
            socket.emit('1');
        }
    };

    const handleSplit = () => {
        if (socket) {
            socket.emit('2');
            const audio = document.getElementById('split_cell');
            if (audio) audio.play();
        }
    };

    if (!isMobile) return null;

    return (
        <div id="mobile">
            <input 
                type="image" 
                id="split" 
                className="split" 
                src="/img/split.png" 
                alt="splitBtn"
                onClick={handleSplit}
            />
            <input 
                type="image" 
                id="feed" 
                className="feed" 
                src="/img/feed.png" 
                alt="feedBtn"
                onClick={handleFeed}
            />
        </div>
    );
};

export default MobileControls;


